import { DialogTipoRechazoPagoConvenio } from './components/convenio-abono/convenio-abono-rechazar.component';

import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './angular-material.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs'
import { FlexLayoutModule } from '@angular/flex-layout';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { LoginComponent } from './components/login/login.component';
import { VotacionComponent } from './components/votacion/votacion.component';
import { BecasComponent } from './components/becas/becas.component';
import { BecasJubComponent } from './components/becas/becas-jub.component';
import { PostulacionesComponent } from './components/postulaciones/postulaciones.component';
import { PostulacionesJubComponent } from './components/postulaciones/postulaciones-jub.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { ConfirmationDialog } from './components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogEspecial } from './components/confirmation-dialog/confirmation-dialog-especial.component';
import { ConfirmationLoginDialog } from './components/confirmation-dialog/confirmation-login-dialog.component';
import { IndexComponent } from './components/index/index.component';
import { IndexJubComponent } from './components/index/index-jub.component';
import { FirmantesComponent } from './components/firmantes/firmantes.component';

import { LoginService } from './services/login/login.service';
import { FirmantesService } from './services/firmantes/firmantes.service';
import { BecasService } from './services/becas/becas.service';
import { PostulacionesService } from './services/postulaciones/postulaciones.service';
import { AfiliacionService } from './services/afiliacion/afiliacion.service';

import { NgxPaginationModule } from 'ngx-pagination';

import { NgxMatAutocompleteControlModule } from 'ngx-mat-autocomplete-control';

import { MsalModule, MsalInterceptor } from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { CursoService } from './services/curso/curso.service';
import { EscolaridadService } from './services/escolaridad/escolaridad.service';
import { TiposService } from './services/tipos/tipos.service';
import { RankingBecasService } from './services/ranking-becas/ranking-becas.service';
import { ProductosService } from './services/productos/productos.service';
import { CursoComponent } from './components/curso/curso.component';
import { EscolaridadComponent } from './components/escolaridad/escolaridad.component';
import { EscolaridadJubComponent } from './components/escolaridad/escolaridad-jub.component';
import { TiposComponent } from './components/tipos/tipos.component';
import { RankingBecasComponent } from './components/ranking-becas/ranking-becas.component';
import { ProductosComponent } from './components/productos/productos.component';
import { DialogEditPostulacion } from './components/postulaciones/postulacion-becas-validar.component';
import { CargaCuotasComponent } from './components/afiliacion/carga-cuotas.component';
import { CuotasPagadasComponent } from './components/afiliacion/cuotas-pagadas.component';
import { DialogEditPrestamo } from './components/prestamos/prestamos-validar.component'
import { DialogEditPrestamoEjecutivo } from './components/prestamos/prestamos-confirmar.component'
import { DialogAnularPrestamo } from './components/prestamos/prestamos-anular.component';
import { DialogEditConvenio } from './components/convenio/convenio-validar-codeudor.component';
import { DialogEditPostulacionEscolaridad } from './components/postulaciones/postulaciones-escolaridad-validar.component';
import { DialogEditPostulacionNacimiento } from './components/postulaciones/postulaciones-nacimiento-validar.component';
import { DialogEditPostulacionMatrimonio} from './components/postulaciones/postulaciones-matrimonio-validar.component';
import { DialogEditPostulacionFallecimiento} from './components/postulaciones/postulaciones-fallecimiento-validar.component';
import { DialogEditPostulacionCatastrofe} from './components/postulaciones/postulaciones-catastrofe-validar.component';
import { DialogEditPostulacionAyudaMedica} from './components/postulaciones-salud/postulaciones-ayudamedica-validar.component';
import { DialogTipoRechazo } from './components/common/postulacion-rechazar.component';
import { DialogTipoRechazoPrestamo } from './components/prestamos/prestamos-rechazar.component';
import { ReembolsosComponent } from './components/reembolsos/reembolsos.component';
import { ReembolsosJubComponent } from './components/reembolsos/reembolsos-jub.component';
import { ReembolsosService } from './services/reembolsos/reembolsos.service';
import { PostulacionesSaludComponent } from './components/postulaciones-salud/postulaciones-salud.component';
import { PostulacionesSaludJubComponent } from './components/postulaciones-salud/postulaciones-salud-jub.component';
import { PostulacionesSaludService } from './services/postulaciones-salud/postulaciones-salud.service';
import { DialogEditPostulacionReembolso } from './components/postulaciones-salud/postulacion-reembolso-validar.component';
import { PrestamosComponent } from './components/prestamos/prestamos.component';
import { PrestamosJubComponent } from './components/prestamos/prestamos-jub.component';
import { PrestamosService } from './services/prestamos/prestamos.service';
import { ConvenioComponent } from './components/convenio/convenio.component';
import { ConvenioJubComponent } from './components/convenio/convenio-jub.component';
import { ConvenioColaboracionComponent } from './components/convenio/convenio-colaboracion.component';
import { ConvenioColaboracionJubComponent } from './components/convenio/convenio-colaboracion-jub.component';
import { ConsultaPrestamosService } from './services/consulta-prestamos/consulta-prestamos.service';
import { ConsultaPrestamosComponent } from './components/consulta-prestamos/consulta-prestamos.component';
import { ConsultaPrestamosJubComponent } from './components/consulta-prestamos/consulta-prestamos-jub.component';
import { ConsultaConvenioService } from './services/consulta-convenio/consulta-convenio.service';
import { ConsultaConvenioComponent } from './components/consulta-convenio/consulta-convenio.component';
import { ConsultaConvenioJubComponent } from './components/consulta-convenio/consulta-convenio-jub.component';
import { ConvenioService } from './services/convenio/convenio.service';
import { PagosComponent } from './components/pagos/pagos.component';
import { CargaConveniosComponent } from './components/carga-convenios/carga-convenios.component';
import { ListadoPendientesComponent } from './components/listado-pendientes/listado-pendientes.component';
import { SolicitudesAfiliacionComponent } from './components/listado-pendientes/solicitudes-afiliacion.component';
import { CargaDescuentosComponent } from './components/carga-descuentos/carga-descuentos.component';
import { CargaAbonosComponent } from './components/carga-abonos/carga-abonos.component';
import { PagosService } from './services/pagos/pagos.service';
import { NacimientoService } from './services/nacimiento/nacimiento.service';
import { MatrimonioService } from './services/matrimonio/matrimonio.service';
import { CatastrofeService } from './services/catastrofe/catastrofe.service';
import { FallecimientoService } from './services/fallecimiento/fallecimiento.service';
import { DialogAnularConvenio } from './components/convenio/convenio-anular.component';
import { CargaConveniosService } from './services/carga-convenios/carga-convenios.service';
import { CargaAbonosService } from './services/carga-abonos/carga-abonos.service';
import { GruposPagoComponent } from './components/grupos-pago/grupos-pago.component';
import { GruposPagoService } from './services/grupos-pago/grupos-pago.service';
import { ConsultaPostulacionesComponent } from './components/consulta-postulaciones/consulta-postulaciones.component';
import { ConsultaPostulacionesService } from './services/consulta-postulaciones/consulta-postulaciones.service';
import { DialogCodigoFirma } from './components/grupos-pago/codigo-firma.component';
import { DialogSegundoCodigoFirma } from './components/grupos-pago/codigo-segunda-firma.component';
import { MantenedorUsuariosComponent } from './components/mantenedor-usuarios/mantenedor-usuarios.component';
import { MantenedorUsuariosService } from './services/mantenedor-usuarios/mantenedor-usuarios.service';
import { DialogCreaUsuario } from './components/mantenedor-usuarios/crear-usuario.component';
import { DialogEditaUsuario } from './components/mantenedor-usuarios/edita-usuario.component';
import { MantenedorProveedorComponent } from './components/mantenedor-proveedor/mantenedor-proveedor.component';
import { MantenedorConvenioColaboracionComponent } from './components/mantenedor-convenio-colaboracion/mantenedor-convenio-colaboracion.component';
import { MantenedorProveedorService } from './services/mantenedor-proveedor/mantenedor-proveedor.service';
import { MantenedorConvenioColaboracionService } from './services/mantenedor-convenio-colaboracion/mantenedor-convenio-colaboracion.service';
import { DialogCrearProveedor } from './components/mantenedor-proveedor/crear-proveedor.component';
import { DialogEditaProveedor } from './components/mantenedor-proveedor/edita-proveedor.component';
import { DialogEditaConvenioColaboracion } from './components/mantenedor-convenio-colaboracion/edita-convenio-colaboracion.component';
import { MantenedorCargasComponent } from './components/mantenedor-cargas/mantenedor-cargas.component';
import { DialogCrearConvenioColaboracion } from './components/mantenedor-convenio-colaboracion/crear-convenio-colaboracion.component';
import { DialogRechazarSolicitudAfiliacionComponent } from './components/solicitud-afiliacion/dialog-rechazar-solicitud-afiliacion.component';
import { DialogDesafiliarAfiliacionComponent } from './components/solicitud-afiliacion/dialog-desafiliar-afiliacion.component';
import { DialogSolicitarDesafiliarAfiliacionComponent } from './components/solicitud-afiliacion/dialog-solicitar-desafiliar-afiliacion.component';
import { DialogObservacionHistoricoComponent } from './components/solicitud-afiliacion/dialog-observacion-historico.component';
import { DialogCreaCarga } from './components/mantenedor-cargas/crear-carga.component';
import { DialogEditaCarga } from './components/mantenedor-cargas/edita-carga.component';
import { MantenedorCargasService } from './services/mantenedor-cargas/mantenedor-cargas.service';
import { CargasMasivasComponent } from './components/cargas-masivas/cargas-masivas.component';
import { CargasMasivasService } from './services/cargas-masivas/cargas-masivas.service';
import { DialogCreaCargaMasiva } from './components/cargas-masivas/crear-cargas-masivas.component';
import { DialogExportarExcel } from './components/grupos-pago/exportar-excel.component';
import { ModalInfoBeneficiario } from './components/common/modal-info-beneficiario.component';
import { ModalInfoRechazoBeneficiario } from './components/common/modal-info-rechazo-beneficiario.component';
import { ModalInfoPagadaBeneficiario } from './components/common/modal-info-pagada-beneficiario.component';
import { ModalInfoRechazoCompaniaBeneficiario } from './components/common/modal-info-rechazo-compania-beneficiario.component';
import { PrestamoAbonoComponent } from './components/prestamo-abono/prestamo-abono.component';
import { PrestamoAbonoJubComponent } from './components/prestamo-abono/prestamo-abono-jub.component';
import { PrestamoAbonoService } from './services/prestamo-abono/prestamo-abono.service';
import { DialogPagoPrestamo } from './components/prestamo-abono/prestamo-pago.component';
import { ConsultaPagosPrestamosComponent } from './components/consulta-pagos-prestamos/consulta-pagos-prestamos.component';
import { ConsultaPagosPrestamosService } from './services/consulta-pagos-prestamos/consulta-pagos-prestamos.service';
import { DialogValidarPagoPrestamo } from './components/prestamo-abono/prestamo-validar-pago.component';
import { DialogValidarPagoAfiliado } from './components/afiliacion/afiliado-validar-pago.component';
import { DialogMostrarPagoAfiliado } from './components/afiliacion/afiliado-mostrar-pago.component';
import { DialogEditConvenioEjecutivo } from './components/convenio/convenio-validar-ejecutivo.component';
import { DialogTipoRechazoConvenio } from './components/convenio/convenio-rechazar.component';
import { CodeudoresComponent } from './components/mantenedor-codeudores/codeudores.component';
import { ConvenioAbonoComponent } from './components/convenio-abono/convenio-abono.component';
import { ConvenioAbonoJubComponent } from './components/convenio-abono/convenio-abono-jub.component';
import { DialogPagoConvenio } from './components/convenio-abono/convenio-pago.component';
import { DialogValidarPagoConvenio } from './components/convenio-abono/convenio-validar-pago.component';
import { ConvenioAbonoService } from './services/convenio-abono/convenio-abono.service';
import { ConsultaPagosConvenioComponent } from './components/consulta-pagos-convenio/consulta-pagos-convenio.component';
import { ConsultaPagosConvenioService } from './services/consulta-pagos-convenio/consulta-pagos-convenio.service';
import { NacimientoComponent } from './components/nacimiento/nacimiento.component';
import { NacimientoJubComponent } from './components/nacimiento/nacimiento-jub.component';
import { MatrimonioComponent } from './components/matrimonio/matrimonio.component';
import { MatrimonioJubComponent } from './components/matrimonio/matrimonio-jub.component';
import { CatastrofeComponent } from './components/catastrofe/catastrofe.component';
import { CatastrofeJubComponent } from './components/catastrofe/catastrofe-jub.component';
import { FallecimientoComponent } from './components/fallecimiento/fallecimiento.component';
import { FallecimientoJubComponent } from './components/fallecimiento/fallecimiento-jub.component';
import { AfiliacionComponent } from './components/afiliacion/afiliacion.component';
import { DesafiliacionComponent } from './components/desafiliacion/desafiliacion.component';
import { AfiliacionTab1Component } from './components/afiliacion/afiliacion-tab1.component';
import { AfiliacionTab2Component } from './components/afiliacion/afiliacion-tab2.component';
import { AfiliacionTab3Component } from './components/afiliacion/afiliacion-tab3.component';
import { AfiliacionTab4Component } from './components/afiliacion/afiliacion-tab4.component';
import { AfiliacionTab5Component } from './components/afiliacion/afiliacion-tab5.component';
import { AfiliacionTab6Component } from './components/afiliacion/afiliacion-tab6.component';
import { AfiliacionTab7Component } from './components/afiliacion/afiliacion-tab7.component';
import { AfiliacionTab8Component } from './components/afiliacion/afiliacion-tab8.component';
import { AfiliacionTab9Component } from './components/afiliacion/afiliacion-tab9.component';
import { DialogAnularReversarCuota } from './components/afiliacion/cuota-pago-anular.component';
import { DialogPagoCuota } from './components/afiliacion/cuota-pago.component';
import { ConsultaPagosAfiliadoComponent } from './components/afiliacion/consulta-pagos-afiliado.component';
import { AyudaMedicaComponent } from './components/ayuda-medica/ayuda-medica.component';
import { AyudaMedicaJubComponent } from './components/ayuda-medica/ayuda-medica-jub.component';
import { SolicitudAfiliacionComponent } from './components/solicitud-afiliacion/solicitud-afiliacion.component';
import { AprobacionSolicitudAfiliacionComponent } from './components/solicitud-afiliacion/aprobacion-solicitud-afiliacion.component';
import { AyudaMedicaService } from './services/ayuda-medica/ayuda-medica.service';
import { TextosService } from './services/textos/textos.service';
import { VotacionService } from './services/votacion/votacion.service';
import { ConsultaAyudaMedicaService } from './services/consulta-ayuda-medica/consulta-ayuda-medica.service';
import { DialogTipoRechazoPagoPrestamo } from './components/prestamo-abono/prestamo-abono-rechazar.component';
import { CargaDescuentosService } from './services/carga-descuentos/carga-descuentos.service';
import { DialogTipoRechazoCuotaPagoAfiliado } from './components/afiliacion/afiliacion-cuota-rechazar.component';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    VotacionComponent,
    BecasComponent,
    BecasJubComponent,
    IndexComponent,
    IndexJubComponent,
    FirmantesComponent,
    PostulacionesComponent,
    PostulacionesJubComponent,
    AlertDialogComponent,
    ConfirmationDialog,
    ConfirmationDialogEspecial,
    ConfirmationLoginDialog,
    CursoComponent,
    EscolaridadComponent,
    EscolaridadJubComponent,
    TiposComponent,
    RankingBecasComponent,
    ProductosComponent,
    DialogEditPostulacion,
    DialogEditPrestamo,
    DialogEditPrestamoEjecutivo,
    DialogAnularPrestamo,
    DialogAnularConvenio,
    DialogEditConvenio,
    DialogEditConvenioEjecutivo,
    DialogTipoRechazoConvenio,
    DialogEditPostulacionEscolaridad,
    DialogEditPostulacionNacimiento,
    DialogEditPostulacionMatrimonio,
    DialogEditPostulacionFallecimiento,
    DialogEditPostulacionCatastrofe,
    DialogTipoRechazo,
    DialogTipoRechazoPrestamo,
    DialogCodigoFirma,
    DialogSegundoCodigoFirma,
    ReembolsosComponent,
    ReembolsosJubComponent,
    PostulacionesSaludComponent,
    PostulacionesSaludJubComponent,
    DialogEditPostulacionReembolso,
    PagosComponent,
    PrestamosComponent,
    PrestamosJubComponent,
    ConsultaConvenioComponent,
    ConsultaConvenioJubComponent,
    ConsultaPrestamosComponent,
    ConsultaPrestamosJubComponent,
    ConvenioComponent,  
    ConvenioJubComponent,
    ConvenioColaboracionComponent,  
    ConvenioColaboracionJubComponent, 
    CargaConveniosComponent,
    ListadoPendientesComponent,
    SolicitudesAfiliacionComponent,
    CargaDescuentosComponent,
    CargaAbonosComponent,
    GruposPagoComponent,
    ConsultaPostulacionesComponent,
    MantenedorUsuariosComponent,
    CodeudoresComponent,
    MantenedorConvenioColaboracionComponent,
    DialogCreaUsuario,
    DialogEditaUsuario,
    MantenedorCargasComponent,
    MantenedorProveedorComponent,
    DialogCrearProveedor,
    DialogEditaProveedor,
    DialogCrearConvenioColaboracion,
    DialogEditaConvenioColaboracion,
    DialogCreaCarga,
    DialogEditaCarga,
    DialogTipoRechazoCuotaPagoAfiliado,
    DialogExportarExcel,
    CargasMasivasComponent,
    NacimientoComponent,
    NacimientoJubComponent,
    MatrimonioComponent,
    MatrimonioJubComponent,
    CatastrofeComponent,
    CatastrofeJubComponent,
    FallecimientoComponent,
    FallecimientoJubComponent,
    AfiliacionComponent,
    DesafiliacionComponent,
    AfiliacionTab1Component,
    AfiliacionTab2Component,
    AfiliacionTab3Component,
    AfiliacionTab4Component,
    AfiliacionTab5Component,
    AfiliacionTab6Component,
    AfiliacionTab7Component,
    AfiliacionTab8Component,
    AfiliacionTab9Component,
    CargaCuotasComponent,
    CuotasPagadasComponent,
    DialogPagoCuota,
    DialogAnularReversarCuota,
    ConsultaPagosAfiliadoComponent,
    DialogRechazarSolicitudAfiliacionComponent,
    DialogDesafiliarAfiliacionComponent,
    DialogSolicitarDesafiliarAfiliacionComponent,
    DialogObservacionHistoricoComponent,
    AyudaMedicaComponent,
    AyudaMedicaJubComponent,    
    SolicitudAfiliacionComponent,
    AprobacionSolicitudAfiliacionComponent,
    DialogCreaCargaMasiva,
    ModalInfoBeneficiario,
    ModalInfoRechazoBeneficiario,
    ModalInfoRechazoCompaniaBeneficiario,
    ModalInfoPagadaBeneficiario,
    PrestamoAbonoComponent, 
    PrestamoAbonoJubComponent,
    ConsultaPagosPrestamosComponent,
    ConvenioAbonoComponent,
    ConvenioAbonoJubComponent,
    DialogPagoPrestamo,
    DialogPagoConvenio,
    ConsultaPagosConvenioComponent,
    DialogValidarPagoConvenio,
    DialogValidarPagoPrestamo,
    DialogValidarPagoAfiliado,
    DialogMostrarPagoAfiliado,
    DialogEditPostulacionAyudaMedica,
    DialogTipoRechazoPagoPrestamo, 
    DialogTipoRechazoPagoConvenio
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatAutocompleteModule,
    MatInputModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FormsModule,
    HttpClientModule,MatTabsModule,
    NgIdleKeepaliveModule.forRoot(),
    NgxPaginationModule,
    NgxMatAutocompleteControlModule,
    
    MsalModule.forRoot({
      auth: {
        clientId: environment.clientId,//'2b75b8c3-3bb0-47fb-8d17-17de0983a886',
        authority:environment.authority,
        redirectUri: environment.redirectUri,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // set to true for IE 11
      },
    },
    {
      popUp: !isIE,
      consentScopes: [
        'user.read',
        'openid',
        'profile',
      ],
      unprotectedResources: [],
      protectedResourceMap: [
        ['Enter_the_Graph_Endpoint_Herev1.0/me', ['user.read']]
      ],
      extraQueryParameters: {  }
    })
  ],
  providers: [LoginService,FirmantesService, BecasService, PostulacionesService, CursoService, EscolaridadService,
              TiposService, RankingBecasService, ProductosService, ReembolsosService, PostulacionesSaludService,

              PagosService, GruposPagoService, ConsultaPostulacionesService,AfiliacionService, MantenedorUsuariosService,
              MantenedorCargasService, CargasMasivasService,PrestamosService,ConvenioService,
              ConsultaPrestamosService,ConvenioAbonoService,
              ConsultaConvenioService,MantenedorProveedorService,MantenedorConvenioColaboracionService,PrestamoAbonoService,
              ConsultaPagosPrestamosService,ConsultaPagosConvenioService,NacimientoService,MatrimonioService, CatastrofeService,
              FallecimientoService, CargaAbonosService,CargaConveniosService,CargaDescuentosService,AyudaMedicaService,
              TextosService,VotacionService,ConsultaAyudaMedicaService,


              { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
